new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_header',
    data: {
        header: {
          Position: 'fixed',
          useFirst: true, // first headerBar
          
          myaccount_options: 'dropdown', // 'none' = no dropdowns, 'dropdown' = hover and dropdown menu;

          isNavUp: true,
          lastScrollTop: 0,

          menuMobile: false,
        },
        searchOpened: false,
        cartOpened: false,
        view_origin_home: (view_origin == 'home') ? true : false
    },
    computed: {
        headerClasses() {
          return {
            'nav-up': this.header.isNavUp,
            [this.header.Position]: true
          };
        }
    },
    watch: {
        searchOpened(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        const searchInput = document.querySelector('.search__header .search__text');
                        if (searchInput) {
                            searchInput.focus();
                            searchInput.click(); // Força o foco no desktop
                        }
                    }, 100);
                });
            }
        }
    },
    created() {
      window.addEventListener("resize", this.screenHandler);
    },
    destroyed() {
      window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
      screenHandler() {
        this.mobile = (window.innerWidth > 991) ? false : true;
      },

      handleClickOutside(event) {
        const searchContainer = document.querySelector('.header__search');
        const searchIcon = document.querySelector('.header__second--tools-search');
        
        if (this.searchOpened && 
            searchContainer && 
            !searchContainer.contains(event.target) && 
            !searchIcon.contains(event.target)) {
          this.searchOpened = false;
        }
      },

      addPaddingHeader() {
        const screenWidth = window.innerWidth;

          const header = document.querySelector('header[data-role="heading"]');
          if (!header) return;
          const headerHeight = header.clientHeight;
          const mainTag = document.querySelector('main[role="main"]');
          const bread = document.querySelector('.breadcrumb');
          const mainDiv = document.querySelector('.main-content');
        
          if (mainTag) {
            mainTag.style.paddingTop = `${headerHeight}px`;
          } else if (mainDiv && bread) {
            if (getComputedStyle(bread).display === 'none') {
              mainDiv.style.paddingTop = `${headerHeight}px`;
            } else {
              mainDiv.style.paddingTop = '0px';
              bread.style.marginTop = `${headerHeight}px`;
            }
          } else if (mainDiv) {
            mainDiv.style.paddingTop = `${headerHeight}px`;
          } else if (bread) {
            bread.style.marginTop = `${headerHeight}px`;
          }
      },

      runSpeechRecognition() {
        var isChromium = window.chrome;
        var winNav = window.navigator;
        var vendorName = winNav.vendor;
        var isOpera = typeof window.opr !== "undefined";
        var isIEedge = winNav.userAgent.indexOf("Edge") > -1;
        var isIOSChrome = winNav.userAgent.match("CriOS");

        if(isChromium !== null && typeof isChromium !== "undefined" && vendorName === "Google Inc." && isOpera === false && isIEedge === false) {
          let output = document.querySelector(".output-search");
          let action = document.querySelector(".microphone");
          let inputMic = document.querySelector(".search__text");
      
          var SpeechRecognition = SpeechRecognition || webkitSpeechRecognition;
  
          var recognition = new SpeechRecognition();
          recognition.continuous = false;
          recognition.lang = 'pt-BR';
  
      
          recognition.onstart = function() {
          if (!output.classList.contains("hide")) {
              output.classList.toggle("hide");
          }   
          
          action.classList.toggle('active');
          };
          
          recognition.onspeechend = function() {
          
          action.classList.toggle('active');
              recognition.stop();
          }
      
          recognition.onresult = function(event) {
              var transcript = event.results[0][0].transcript;
              var confidence = event.results[0][0].confidence * 100;
          
              if(confidence < 50) {
                  inputMic.classList.toggle('not-understand')
                  output.classList.toggle("hide");
                  inputMic.value = "Desculpe não entendi muito bem.";
              } else {
                  inputMic.value = transcript
                  document.querySelector('.button-busca').click()
              };
              
          };
      
          // start recognition
          recognition.start();
        } else return document.querySelector(".microphone-search").remove();
      },

      handleScroll() {
        const st = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
        const scrollDifference = st - this.lastScrollTop;
        const customMobile = document.getElementById('custom-mobile-nav');
        const headerThird = document.getElementById('header-third');
        const quickMenu = document.getElementById('quick-menu-id');
        const whatsappWidget = document.getElementById('widget-whatsapp');
  
        if (st > this.lastScrollTop)
          this.header.isNavUp = false;
        else {
          if (st === 0)
            this.header.isNavUp = true;
        }
  
        if (st >= 90 && scrollDifference > 0) {
          this.header.isNavDown = false;
          this.header.isNavMin = true;
  
          if (customMobile)
            customMobile.classList.add('hide');
  
          if (headerThird)
            headerThird.classList.add('hide');
  
          if (quickMenu) {
            quickMenu.classList.add('hide');
            whatsappWidget.style.bottom = '';
          }
  
        } else {
          this.header.isNavDown = true;
          this.header.isNavMin = false;
          this.header.isNavMenuHide = false;
  
          if (customMobile)
            customMobile.classList.remove('hide');
  
          if (headerThird)
            headerThird.classList.remove('hide');
  
          if (quickMenu) {
            quickMenu.classList.remove('hide');
            whatsappWidget.style.bottom = '79px';
          }
        }
  
        this.lastScrollTop = st;
      },

      setupMarquee() {
        const marquee = document.querySelector('.texto-header__list');
        if (!marquee) return;

        // Pega todos os itens originais
        const originalItems = Array.from(marquee.querySelectorAll('li'));
        const totalWidth = originalItems.reduce((acc, item) => acc + item.offsetWidth, 0);
        const screenWidth = window.innerWidth;

        // Calcula quantas vezes precisamos duplicar para garantir preenchimento
        const timesToDuplicate = Math.ceil((screenWidth) / totalWidth) + 1;

        // Limpa o marquee
        marquee.innerHTML = '';

        // Adiciona os itens duplicados
        for (let i = 0; i < timesToDuplicate; i++) {
          originalItems.forEach(item => {
            const clone = item.cloneNode(true);
            marquee.appendChild(clone);
          });
        }

        // Ajusta a animação baseado no conteúdo total
        const finalWidth = marquee.scrollWidth;
        // Aumentando a velocidade da animação
        const duration = finalWidth / 20;

        marquee.style.animation = `none`;
        setTimeout(() => {
          marquee.style.animation = `marquee ${duration}s linear infinite`;
        }, 0);
      },
    },
    mounted() {
        window.addEventListener('scroll', this.handleScroll);
        document.addEventListener('click', this.handleClickOutside);
        this.addPaddingHeader();
        this.setupMarquee();
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.handleScroll);
        document.removeEventListener('click', this.handleClickOutside);
    }
})

/* Mobile Wrapper */
const mobileNavLinks = document.querySelectorAll('.mobile-nav__link.ewrap');

mobileNavLinks.forEach(link => {
  link.addEventListener('click', function(event) {
    event.preventDefault();
    this.classList.toggle('active');
    const wrapper = this.nextElementSibling;
    if (wrapper && wrapper.tagName === 'UL') {
      wrapper.classList.toggle('active');
    }
  });
});

// waitForElementToExist('#js-texto-header').then(element => {
//   $('#js-texto-header').slick({
//     arrows: false,
//     infinite: true,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     dots: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     speed: 1000,
//   });
// });

var cart_preview_triggers = $('.header__second--tools-cart, .cart-preview-header__close, .cart-preview--overlay, .cart-preview .btn-continue');

cart_preview_triggers.on("click", function (e) {
  $('.header__second--tools-cart-preview').toggleClass('active');
  document.body.classList.toggle('no-scroll');
  document.documentElement.classList.toggle('no-scroll');
});